import { createStoreCreator } from 'lib/store'
import reducer from 'oee/locationBreakdowns/reducers'

export default createStoreCreator(reducer)
